import React, {useState} from 'react';
import {
   View,
   Image,
   StyleSheet,
   Dimensions,
   Text,
   TouchableOpacity,
   SafeAreaView,
   StatusBar,
   Platform,
} from 'react-native';
import {
   courseDetailLowerViewColor,
   couurseDetailButtonColor,
   courseListBGColor,
   appBackground,
   getNavBarHeight,
   drawerListBackgroundColor,
   coureTitleBGGradientColorUpper,
   primaryColor500,
   getStatusBarHeight,
   FONT_FAMILY_REGULAR,
   redirectToBrowser,
   WHITE_ICON_HOVER_TINT_COLOR,
} from '../../utils/utils';
import {useNavigation} from '@react-navigation/native';
import {selectScreenOrientation} from '../../redux/slices/ScreenOrientationSlice';
import {useDispatch, useSelector} from 'react-redux';
import CourseResourcesList from './CourseResourcesList';
import CourseResourceItem from './CourseResourceItem';
import logger from '../../utils/logger';
import {setIsEnrolledPageReload} from '../../redux/slices/EnrolledCourseDataSlice';

const {width, height} = Dimensions.get('window');

function isArrayofJSONObjects(obj) {
   if (Array.isArray(obj)) {
      return obj.every(item => typeof item === 'object' && item !== null);
   }
   return false;
}

const CourseResourceView = props => {
   const isLandscapemode = useSelector(selectScreenOrientation);
   var courseResources = props.resourcesList.CourseResources;
   logger('c-resources: ' + JSON.stringify(courseResources));
   const navigation = useNavigation();
   const [rowHeights, setRowHeights] = useState({});
   const dispatch = useDispatch();
   const [isHover, setHover] = useState(false);

   return (
      <View style={styles.container}>
         {/** Back button and navigatin title  */}
         <View
            style={{
               flexDirection: 'row',
               alignItems: 'center',
               height: !isLandscapemode ? getNavBarHeight() : 88,
               backgroundColor: drawerListBackgroundColor,
               ...Platform.select({
                  web: {
                     height: !isLandscapemode ? 56 : 88,
                  },
               }),
            }}>
            <TouchableOpacity
               onMouseEnter={() => setHover(true)}
               onMouseLeave={() => setHover(false)}
               style={{padding: 10, marginTop: 0}}
               onPress={() => {
                  if (Platform.OS === 'windows') {
                     dispatch(setIsEnrolledPageReload(false));
                  }
                  props.navigation.goBack();
               }}>
               <Image
                  source={require('../../assets/back_arrow.png')}
                  style={{
                     width: !isLandscapemode ? 16 : 24,
                     height: !isLandscapemode ? 16 : 24,
                     marginLeft: !isLandscapemode ? 7 : 10,
                     tintColor: isHover && WHITE_ICON_HOVER_TINT_COLOR,
                  }}
               />
            </TouchableOpacity>
            <Text
               style={{
                  fontSize: !isLandscapemode ? 16 : 24,
                  fontWeight: '600',
                  fontFamily: FONT_FAMILY_REGULAR,
                  color: 'white',
                  marginStart: 15,
                  marginTop: 0,
               }}>
               {'Available Course Resources'}
            </Text>
         </View>

         <View style={{marginVertical: 16, flex: 1, backgroundColor: 'black'}}>
            <CourseResourcesList
               style={{}}
               ItemSeparatorComponent={props => {
                  // here you can access the trailingItem with props.trailingItem
                  return <View style={{height: 16}} />;
               }}
               data={
                  isArrayofJSONObjects(courseResources)
                     ? courseResources
                     : [courseResources]
               }
               getItemLayout={(data, index) => ({
                  length: rowHeights[index],
                  offset: rowHeights[index] * index,
                  index,
               })}
               height={undefined}
               renderItem={({
                  item,
                  iconTintColor,
                  titleColor,
                  isSelected,
                  index,
                  isLandscapemode,
               }) => (
                  <View
                     onLayout={event =>
                        setRowHeights({
                           ...rowHeights,
                           [index]: event.nativeEvent.layout.height,
                        })
                     }>
                     <CourseResourceItem
                        title={item.CourseResourceName}
                        titleColor={titleColor}
                        isSelected={isSelected}
                        index={index}
                        locked={item.locked}
                        isLandscape={isLandscapemode}
                     />
                  </View>
               )}
               keyExtractor={(_, index) => index.toString()} // use index as identifier
               contentContainerStyle={{maxHeight: '40%'}}
               onSelect={item => {
                  logger('pressed course Name: ' + item.CourseResourceURL);
                  Platform.OS !== 'web'
                     ? props.onRowSelected(item.CourseResourceURL)
                     : redirectToBrowser({url: item.CourseResourceURL});
               }}
            />
         </View>
      </View>
   );
};

const styles = StyleSheet.create({
   container: {
      backgroundColor: 'black',
      flex: 1,
   },
   buttonView: {
      backgroundColor: primaryColor500,
      minHeight: 32,
      borderRadius: 6,
      justifyContent: 'center',
   },
   lowerView: {
      width: '100%',
      height: height * 0.08,
      justifyContent: 'center',
      alignItems: 'center',
   },
   lowerViewLandscape: {
      width: 230,
      height: height * 0.08,
      marginTop: 20,
   },
   courseSupportButtonView: {
      backgroundColor: primaryColor500,
      minHeight: 48,
      borderRadius: 6,
      justifyContent: 'center',
      marginHorizontal: 16,
      width: width - 32,
   },
   headerContainer: {
      flex: 1,
      justifyContent: 'center',
      alignItems: 'center',
      height: '10%',
   },
   headerTitle: {
      marginHorizontal: 16,
      marginVertical: 15,
      fontSize: 12,
      fontWeight: '600',
      fontFamily: FONT_FAMILY_REGULAR,
      color: coureTitleBGGradientColorUpper,
      textAlign: 'center',
   },
   buttonTitle: {
      color: 'white',
      fontSize: 16,
      fontWeight: '500',
      textAlign: 'center',
      fontFamily: FONT_FAMILY_REGULAR,
      marginHorizontal: 10,
   },
   buttonTitleLandscape: {
      color: 'white',
      fontSize: 16,
      fontWeight: '500',
      textAlign: 'center',
      fontFamily: FONT_FAMILY_REGULAR,
      marginRight: 10,
   },
   backButtonLandscape: {
      width: 103,
      height: 48,
      borderRadius: 6,
      backgroundColor: primaryColor500,
      justifyContent: 'center',
      marginRight: 15,
   },
   continueButtonLandscape: {
      width: 103,
      height: 48,
      borderRadius: 6,
      backgroundColor: primaryColor500,
      justifyContent: 'center',
      marginRight: 15,
   },
});

export default CourseResourceView;
